import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
import { persistor } from '../Commonlibs/store';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  ListItemIcon,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditIcon from '@mui/icons-material/Edit';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MailIcon from '@mui/icons-material/Mail';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import home from '../assets/lob.png';
import profileIcon from '../assets/iconu.png';
import logoutIcon from '../assets/logf.png';
import combinedLogo from '../assets/pdt-logo-white 1.png';
import proptitle from '../assets/titleprop.png';
import propmenu from '../assets/menugroup.png';
import propside from '../assets/propside.png';
import propsiding from '../assets/propsiding.png'; // ✅ Added import
import pdtnav from '../assets/pdtnav.jpg';
import freeTag from '../assets/redimage.png';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const shouldHidePostPropertyButton =
    location.pathname === '/sell-properties' ||
    location.pathname === '/add-new-property' ||
    location.pathname === '/property-details' ||
    location.pathname === '/amenities' ||
    location.pathname === '/price-details' ||
    location.pathname === '/rent-details';

  const shouldHideDashboardButton =
    location.pathname === '/sell-properties' ||
    location.pathname.startsWith('/sell-properties/') ||
    location.pathname === '/profile' ||
    location.pathname.startsWith('/profile/');

  const [profileData, setProfileData] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      console.error('Error parsing JWT token:', e);
      return null;
    }
  };

  useEffect(() => {
    console.log('Auth state check:');
    console.log('- localStorage token:', localStorage.getItem('auth_token'));
    console.log('- localStorage user_id:', localStorage.getItem('user_id'));
    console.log('- localStorage user_email:', localStorage.getItem('user_email'));
    console.log('- localStorage user_name:', localStorage.getItem('user_name'));
    console.log('- Redux user:', user);
    console.log('- Profile data:', profileData);
  }, [user, profileData]);

  useEffect(() => {
    const parseTokenFromURL = () => {
      try {
        console.log('Current URL:', window.location.href);
        
        if (location.pathname === '/sell-properties') {
          const urlParams = new URLSearchParams(location.search);
          const token = urlParams.get('token');
          const id = urlParams.get('id');
          const email = urlParams.get('email');
          const name = urlParams.get('name');

          console.log('URL Parameters:', { token, id, email, name });

          if (token && id) {
            const decodedToken = parseJwt(token);
            console.log('Decoded token:', decodedToken);

            const userToStore = {
              id: parseInt(id),
              fullName: name || decodedToken?.name || '',
              email: email || decodedToken?.email || '',
              token: token
            };

            console.log('Setting user from URL params:', userToStore);

            localStorage.setItem('auth_token', token);
            localStorage.setItem('user_id', id.toString());
            localStorage.setItem('user_email', email || '');
            localStorage.setItem('user_name', name || '');

            dispatch(setUser(userToStore));
            fetchUserProfile();
            window.history.replaceState({}, document.title, '/sell-properties');
          }
        }
      } catch (error) {
        console.error('Error parsing token from URL:', error);
      }
    };

    parseTokenFromURL();
  }, [location, dispatch]);

  useEffect(() => {
    const checkStoredToken = () => {
      if (!user) {
        const storedToken = localStorage.getItem('auth_token');
        const storedId = localStorage.getItem('user_id');
        const storedEmail = localStorage.getItem('user_email');
        const storedName = localStorage.getItem('user_name');

        if (storedToken && storedId) {
          const userToStore = {
            id: parseInt(storedId),
            email: storedEmail || '',
            fullName: storedName || '',
            token: storedToken
          };
          dispatch(setUser(userToStore));
        }
      }
    };

    checkStoredToken();
  }, [user, dispatch]);

  const fetchUserProfile = async () => {
    try {
      const storedToken = localStorage.getItem('auth_token');
      const storedId = localStorage.getItem('user_id');

      console.log('Fetching profile with stored credentials:', {
        storedId,
        tokenExists: !!storedToken,
        reduxUser: user
      });

      const id = user?.id || storedId;
      const token = user?.token || storedToken;

      if (id && token) {
        console.log(`Making API call to fetch user ${id} profile`);
        const response = await fetch(
          `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) {
          console.error('Profile fetch failed with status:', response.status);
          return;
        }

        const data = await response.json();
        console.log('Profile API response:', data);

        if (data.status === "SUCCESS" && data.result) {
          setProfileData(data.result);

          const updatedUser = {
            id: parseInt(id),
            token: token,
            fullName: data.result.full_name,
            email: data.result.email_id,
            contactNumber: data.result.contact_number,
            profileImage: data.result.profile_image,
            authProvider: data.result.auth_provider,
            googleId: data.result.google_id,
            location: data.result.location,
            occupation: data.result.occupation,
            professionalTitle: data.result.professional_title,
            companyName: data.result.company_name,
            yearsOfExperience: data.result.years_of_experience,
            licenseNumber: data.result.license_number,
            bio: data.result.bio,
            website: data.result.website,
            linkedin: data.result.linkedin,
            facebook: data.result.facebook,
          };

          console.log('Updating user in Redux with:', updatedUser);

          if (data.result.auth_provider === 'google') {
            dispatch(setGoogleUser(updatedUser));
          } else {
            dispatch(setUser(updatedUser));
          }

          localStorage.setItem('user_name', data.result.full_name);
          localStorage.setItem('user_email', data.result.email_id);
        } else {
          console.error('Failed to get valid profile data:', data);
        }
      } else {
        console.warn('Missing user ID or token, cannot fetch profile');
      }
    } catch (err) {
      console.error('Error fetching profile:', err);
    }
  };

  useEffect(() => {
    if (user?.id && user?.token) {
      fetchUserProfile();
    }
  }, [user?.id, user?.token]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'profile_updated' && e.newValue === 'true') {
        console.log('Profile update detected, refreshing navbar data...');
        fetchUserProfile();
        localStorage.removeItem('profile_updated');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    const intervalId = setInterval(() => {
      if (localStorage.getItem('profile_updated') === 'true') {
        console.log('Profile update detected (same tab), refreshing navbar data...');
        fetchUserProfile();
        localStorage.removeItem('profile_updated');
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, [user?.id, user?.token]);

  useEffect(() => {
    console.log('Current user in Redux:', user);
    console.log('Profile data:', profileData);
  }, [user, profileData]);

  const openLogoutDialog = () => {
    setLogoutDialogOpen(true);
    setDrawerOpen(false);
  };

  const closeLogoutDialog = () => {
    setLogoutDialogOpen(false);
  };

  const handleLogout = async () => {
    try {
      console.log('🚪 Starting logout process...');
      setProfileData(null);
      dispatch(logout());
      await persistor.purge();
      await persistor.flush();
      localStorage.clear();
      sessionStorage.clear();
      closeLogoutDialog();
      navigate('/', { replace: true });
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
      console.log('✅ Logout completed successfully');
    } catch (error) {
      console.error('❌ Error during logout:', error);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setDrawerOpen(open);
  };

  const handleListPropertyClick = () => {
    setDrawerOpen(false);
    
    if (!user) {
      navigate('/login');
      return;
    }

    navigate('/add-new-property');
  };

  const handleDashboardClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties');
  };

  const handleProfileClick = () => {
    setDrawerOpen(false);
    navigate('/profile/edit');
  };

  const handleMyPropertiesClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/seeAll');
  };

  const handleInboxClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/inbox');
  };

  const handleTransactionsClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/transactions');
  };

  const handleMyActivityClick = () => {
    setDrawerOpen(false);
    navigate('/profile');
  };

  const handleWishlistClick = () => {
    setDrawerOpen(false);
    navigate('/profile/wishlist');
  };

  const handleRecentSearchesClick = () => {
    setDrawerOpen(false);
    navigate('/profile/recent-searches');
  };

  const drawerContent = (
    <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
      <List>
        {user ? (
          <>
            <ListItem button onClick={handleDashboardClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Dashboard"
              />
            </ListItem>

            <ListItem button onClick={handleProfileClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Edit Profile"
              />
            </ListItem>

            <ListItem button onClick={handleMyPropertiesClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="My Properties"
              />
            </ListItem>

            <ListItem button onClick={handleInboxClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Inbox"
              />
            </ListItem>

            <ListItem button onClick={handleTransactionsClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Transactions"
              />
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem button onClick={handleMyActivityClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="My Activity"
              />
            </ListItem>

            <ListItem button onClick={handleWishlistClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Wishlist"
              />
            </ListItem>

            <ListItem button onClick={handleRecentSearchesClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Recent Searches"
              />
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem button onClick={openLogoutDialog}>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Logout"
              />
            </ListItem>
          </>
        ) : (
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500, textAlign: 'center' } }}
              primary="Please sign in to access menu"
            />
          </ListItem>
        )}
      </List>
    </Box>
  );

  const userName = user?.fullName || profileData?.full_name || '';
  const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

  return (
    <Box sx={{ fontFamily: 'Outfit' }}>
      {/* ✅ CSS Animation for FREE badge */}
      <style>
        {`
          @keyframes swingBadge {
            0%, 100% {
              transform: rotate(-10deg);
            }
            50% {
              transform: rotate(10deg);
            }
          }
          
          .free-badge {
            animation: swingBadge 2s ease-in-out infinite;
            transform-origin: top center;
          }
        `}
      </style>

      <AppBar
        position="fixed"
        elevation={3}
        sx={{
          backgroundColor: '#fff',
          px: 2,
          py: 1,
          transition: 'background-color 0.3s ease, border-radius 0.3s ease',
          borderRadius: scrolled ? '0 0 50px 50px' : 0,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          color: '#000',
          minHeight: '64px',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'visible',
            minHeight: { xs: '56px', sm: '64px' },
            px: { xs: 0, sm: 2 },
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Box
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: { xs: 0.5, sm: 1 }, 
                cursor: 'pointer' 
              }}
              onClick={() => navigate('/')}
            >
              {/* Desktop - Show home + proptitle */}
              <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>
                <img 
                  src={home} 
                  alt="logo" 
                  style={{ height: 38 }} 
                />
                <img 
                  src={proptitle} 
                  alt="logo" 
                  style={{ height: 18, width: 250 }} 
                />
              </Box>
              
              {/* ✅ MODIFIED: Mobile - Show home + propsiding */}
              <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 0.5 }}>
                <img 
                  src={home} 
                  alt="logo" 
                  style={{ 
                    height: window.innerWidth < 400 ? 38 : 32,
                    objectFit: 'contain'
                  }} 
                />
                <img 
                  src={propsiding} 
                  alt="logo" 
                  style={{ 
                    height: window.innerWidth < 400 ? 22 : 16,
                    maxWidth: '60vw',
                    objectFit: 'contain'
                  }} 
                />
              </Box>
            </Box>
          </Box>

          {/* Desktop View */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
            {user ? (
              <>
                <Typography noWrap sx={{ color: '#000' }}>
                  Hello,
                  <span style={{ color: '#000', fontWeight: 600 }}>
                    {userName || 'User'}
                  </span>
                </Typography>

                <Box
                  onClick={handleProfileClick}
                  sx={{
                    backgroundColor: '#ffc107',
                    borderRadius: '50%',
                    width: 56,
                    height: 56,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    key={userProfileImage}
                    src={userProfileImage}
                    alt="user"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      e.target.src = profileIcon;
                    }}
                  />
                </Box>

                {/* ✅ Desktop Post Property with Badge Below - #2563EB BUTTON */}
                {!shouldHidePostPropertyButton && (
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                      variant="contained"
                      onClick={handleListPropertyClick}
                      sx={{ 
                        color: '#fff',
                        backgroundColor: '#2563EB',
                        textTransform: 'none', 
                        fontWeight: 500,
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: '#1d4ed8',
                        }
                      }}
                    >
                      Post Property
                    </Button>
                    
                    {/* Animated FREE Badge - Positioned Below Button */}
                    <Box
                      className="free-badge"
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '32px',
                        height: '32px',
                        zIndex: 10,
                        pointerEvents: 'none',
                        marginTop: '-8px'
                      }}
                    >
                      <img 
                        src={freeTag} 
                        alt="free" 
                        style={{ 
                          width: '100%', 
                          height: '100%',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Box>
                )}

                {/* ✅ Dashboard Button - #2563EB */}
                {!shouldHideDashboardButton && (
                  <Button
                    variant="contained"
                    startIcon={<DashboardIcon />}
                    onClick={handleDashboardClick}
                    sx={{
                      color: '#fff',
                      backgroundColor: '#2563EB',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      textTransform: 'none',
                      fontWeight: 500,
                      borderRadius: '8px',
                      '&:hover': {
                        backgroundColor: '#1d4ed8',
                      }
                    }}
                  >
                    Dashboard
                  </Button>
                )}

                {/* ✅ Logout Button - #2563EB */}
                <Button
                  variant="contained"
                  onClick={openLogoutDialog}
                  sx={{
                    color: '#fff',
                    backgroundColor: '#2563EB',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#1d4ed8',
                    }
                  }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                {/* ✅ Sign In Button - #2563EB */}
                <Button
                  variant="contained"
                  component={Link}
                  to="/login"
                  sx={{ 
                    color: '#fff',
                    backgroundColor: '#2563EB',
                    fontWeight: 500,
                    textTransform: 'none',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#1d4ed8',
                    }
                  }}
                >
                  Sign In
                </Button>

                {/* ✅ Desktop Post Property for Non-logged with Badge Below - #2563EB BUTTON */}
                {!shouldHidePostPropertyButton && (
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                      variant="contained"
                      onClick={handleListPropertyClick}
                      sx={{ 
                        color: '#fff',
                        backgroundColor: '#2563EB',
                        textTransform: 'none',
                        fontWeight: 500,
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: '#1d4ed8',
                        }
                      }}
                    >
                      Post Property
                    </Button>
                    
                    {/* Animated FREE Badge - Positioned Below Button */}
                    <Box
                      className="free-badge"
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '32px',
                        height: '32px',
                        zIndex: 10,
                        pointerEvents: 'none',
                        marginTop: '-8px'
                      }}
                    >
                      <img 
                        src={freeTag} 
                        alt="free" 
                        style={{ 
                          width: '100%', 
                          height: '100%',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>

          {/* Mobile View */}
          <Box sx={{ 
            display: { xs: 'flex', md: 'none' }, 
            alignItems: 'center', 
            gap: { xs: 0.5, sm: 1 },
            mr: 1
          }}>
            {!user ? (
              <>
                {/* ✅ Sign In Button - Mobile - #2563EB */}
                <Button
                  variant="contained"
                  component={Link}
                  to="/login"
                  size="small"
                  sx={{ 
                    color: '#fff',
                    backgroundColor: '#2563EB',
                    fontWeight: 500,
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    minWidth: 'auto',
                    px: { xs: 1, sm: 1.5 },
                    textTransform: 'none',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#1d4ed8',
                    }
                  }}
                >
                  Sign In
                </Button>

                {/* ✅ Mobile Post Property with Badge Below - #2563EB */}
                {!shouldHidePostPropertyButton && (
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleListPropertyClick}
                      sx={{ 
                        color: '#fff',
                        backgroundColor: '#2563EB',
                        fontWeight: 500,
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        minWidth: 'auto',
                        px: { xs: 1, sm: 1.5 },
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: '#1d4ed8',
                        }
                      }}
                    >
                      Post Property
                    </Button>
                    
                    {/* Animated FREE Badge - Positioned Below Button */}
                    <Box
                      className="free-badge"
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: { xs: '24px', sm: '28px' },
                        height: { xs: '24px', sm: '28px' },
                        zIndex: 10,
                        pointerEvents: 'none',
                        marginTop: '-6px'
                      }}
                    >
                      <img 
                        src={freeTag} 
                        alt="free" 
                        style={{ 
                          width: '100%', 
                          height: '100%',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Box>
                )}
              </>
            ) : (
              <>
                                {/* ✅ Mobile Post Property for Logged Users with Badge Below - #2563EB */}
                {!shouldHidePostPropertyButton && (
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleListPropertyClick}
                      sx={{ 
                        color: '#fff',
                        backgroundColor: '#2563EB',
                        fontWeight: 500,
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        minWidth: 'auto',
                        px: { xs: 1, sm: 1.5 },
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: '#1d4ed8',
                        }
                      }}
                    >
                      Post Property
                    </Button>
                    
                    {/* Animated FREE Badge - Positioned Below Button */}
                    <Box
                      className="free-badge"
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: { xs: '24px', sm: '28px' },
                        height: { xs: '24px', sm: '28px' },
                        zIndex: 10,
                        pointerEvents: 'none',
                        marginTop: '-6px'
                      }}
                    >
                      <img 
                        src={freeTag} 
                        alt="free" 
                        style={{ 
                          width: '100%', 
                          height: '100%',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>

          {/* Menu Icon - Mobile (Only show when user is logged in) */}
          {user && (
            <IconButton
              onClick={toggleDrawer(true)}
              sx={{ 
                display: { md: 'none' }, 
                color: 'inherit',
                p: { xs: 0.5, sm: 1 }
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerContent}
      </Drawer>

      <Toolbar />

      {/* Logout Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={closeLogoutDialog}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">
          Logout Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={closeLogoutDialog} 
            color="primary"
            sx={{ borderRadius: '8px' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleLogout} 
            color="primary" 
            variant="contained"
            sx={{ borderRadius: '8px' }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Navbar;













// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import propmenu from '../assets/menugroup.png';
// import pdtnav from '../assets/pdtnav.jpg';
// import freeTag from '../assets/redimage.png';

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/amenities' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   const [profileData, setProfileData] = useState(null);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
        
//         if (location.pathname === '/sell-properties') {
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             dispatch(setUser(userToStore));
//             fetchUserProfile();
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id && user?.token) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected, refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       console.log('🚪 Starting logout process...');
//       setProfileData(null);
//       dispatch(logout());
//       await persistor.purge();
//       await persistor.flush();
//       localStorage.clear();
//       sessionStorage.clear();
//       closeLogoutDialog();
//       navigate('/', { replace: true });
//       setTimeout(() => {
//         window.location.href = '/';
//       }, 100);
//       console.log('✅ Logout completed successfully');
//     } catch (error) {
//       console.error('❌ Error during logout:', error);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = '/';
//     }
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   const handleListPropertyClick = () => {
//     setDrawerOpen(false);
    
//     if (!user) {
//       navigate('/login');
//       return;
//     }

//     navigate('/add-new-property');
//   };

//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         {user ? (
//           <>
//             <ListItem button onClick={handleDashboardClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Dashboard"
//               />
//             </ListItem>

//             <ListItem button onClick={handleProfileClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Edit Profile"
//               />
//             </ListItem>

//             <ListItem button onClick={handleMyPropertiesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Properties"
//               />
//             </ListItem>

//             <ListItem button onClick={handleInboxClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Inbox"
//               />
//             </ListItem>

//             <ListItem button onClick={handleTransactionsClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Transactions"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={handleMyActivityClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Activity"
//               />
//             </ListItem>

//             <ListItem button onClick={handleWishlistClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Wishlist"
//               />
//             </ListItem>

//             <ListItem button onClick={handleRecentSearchesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Recent Searches"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={openLogoutDialog}>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Logout"
//               />
//             </ListItem>
//           </>
//         ) : (
//           <ListItem>
//             <ListItemText
//               primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500, textAlign: 'center' } }}
//               primary="Please sign in to access menu"
//             />
//           </ListItem>
//         )}
//       </List>
//     </Box>
//   );

//   const userName = user?.fullName || profileData?.full_name || '';
//   const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       {/* ✅ CSS Animation for FREE badge */}
//       <style>
//         {`
//           @keyframes swingBadge {
//             0%, 100% {
//               transform: rotate(-10deg);
//             }
//             50% {
//               transform: rotate(10deg);
//             }
//           }
          
//           .free-badge {
//             animation: swingBadge 2s ease-in-out infinite;
//             transform-origin: top center;
//           }
//         `}
//       </style>

//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             overflow: 'visible',
//             minHeight: { xs: '56px', sm: '64px' },
//             px: { xs: 0, sm: 2 },
//           }}
//         >
//           {/* Logo Section */}
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//             <Box
//               sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 gap: { xs: 0.5, sm: 1 }, 
//                 cursor: 'pointer' 
//               }}
//               onClick={() => navigate('/')}
//             >
//               <img 
//                 src={home} 
//                 alt="logo" 
//                 style={{ 
//                   height: window.innerWidth < 600 ? 32 : 38 
//                 }} 
//               />
//               {/* Desktop - Show proptitle */}
//               <Box sx={{ display: { xs: 'none', md: 'block' } }}>
//                 <img 
//                   src={proptitle} 
//                   alt="logo" 
//                   style={{ height: 18, width: 250 }} 
//                 />
//               </Box>
//               {/* Mobile - Show propmenu */}
//               <Box sx={{ display: { xs: 'block', md: 'none' } }}>
//                 <img 
//                   src={propmenu} 
//                   alt="logo" 
//                   style={{ 
//                     height: window.innerWidth < 400 ? 26 : 18,
//                     maxWidth: '100%',
//                     objectFit: 'contain'
//                   }} 
//                 />
//               </Box>
//             </Box>
//           </Box>

//           {/* Desktop View */}
//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     key={userProfileImage}
//                     src={userProfileImage}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {/* ✅ Desktop Post Property with Badge Below - #2563EB BUTTON */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       variant="contained"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#fff',
//                         backgroundColor: '#2563EB',
//                         textTransform: 'none', 
//                         fontWeight: 500,
//                         '&:hover': {
//                           backgroundColor: '#1d4ed8',
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: '32px',
//                         height: '32px',
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-8px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}

//                 {/* ✅ Dashboard Button - #2563EB */}
//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#2563EB',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#1d4ed8',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 {/* ✅ Logout Button - #2563EB */}
//                 <Button
//                   variant="contained"
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#2563EB',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                     '&:hover': {
//                       backgroundColor: '#1d4ed8',
//                     }
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 {/* ✅ Sign In Button - #2563EB */}
//                 <Button
//                   variant="contained"
//                   component={Link}
//                   to="/login"
//                   sx={{ 
//                     color: '#fff',
//                     backgroundColor: '#2563EB',
//                     fontWeight: 500,
//                     textTransform: 'none',
//                     '&:hover': {
//                       backgroundColor: '#1d4ed8',
//                     }
//                   }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* ✅ Desktop Post Property for Non-logged with Badge Below - #2563EB BUTTON */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       variant="contained"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#fff',
//                         backgroundColor: '#2563EB',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         '&:hover': {
//                           backgroundColor: '#1d4ed8',
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: '32px',
//                         height: '32px',
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-8px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Mobile View */}
//           <Box sx={{ 
//             display: { xs: 'flex', md: 'none' }, 
//             alignItems: 'center', 
//             gap: { xs: 0.5, sm: 1 },
//             mr: 1
//           }}>
//             {!user ? (
//               <>
//                 {/* ✅ Sign In Button - Mobile - #2563EB */}
//                 <Button
//                   variant="contained"
//                   component={Link}
//                   to="/login"
//                   size="small"
//                   sx={{ 
//                     color: '#fff',
//                     backgroundColor: '#2563EB',
//                     fontWeight: 500,
//                     fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                     minWidth: 'auto',
//                     px: { xs: 1, sm: 1.5 },
//                     textTransform: 'none',
//                     '&:hover': {
//                       backgroundColor: '#1d4ed8',
//                     }
//                   }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* ✅ Mobile Post Property with Badge Below - #2563EB */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#fff',
//                         backgroundColor: '#2563EB',
//                         fontWeight: 500,
//                         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                         minWidth: 'auto',
//                         px: { xs: 1, sm: 1.5 },
//                         textTransform: 'none',
//                         whiteSpace: 'nowrap',
//                         '&:hover': {
//                           backgroundColor: '#1d4ed8',
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: { xs: '24px', sm: '28px' },
//                         height: { xs: '24px', sm: '28px' },
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-6px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             ) : (
//               <>
//                 {/* ✅ Mobile Post Property for Logged Users with Badge Below - #2563EB */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#fff',
//                         backgroundColor: '#2563EB',
//                         fontWeight: 500,
//                         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                         minWidth: 'auto',
//                         px: { xs: 1, sm: 1.5 },
//                         textTransform: 'none',
//                         whiteSpace: 'nowrap',
//                         '&:hover': {
//                           backgroundColor: '#1d4ed8',
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                                         {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: { xs: '24px', sm: '28px' },
//                         height: { xs: '24px', sm: '28px' },
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-6px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Menu Icon - Mobile (Only show when user is logged in) */}
//           {user && (
//             <IconButton
//               onClick={toggleDrawer(true)}
//               sx={{ 
//                 display: { md: 'none' }, 
//                 color: 'inherit',
//                 p: { xs: 0.5, sm: 1 }
//               }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       <Toolbar />

//       {/* Logout Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Navbar;








// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import propmenu from '../assets/menugroup.png';
// import pdtnav from '../assets/pdtnav.jpg';
// import freeTag from '../assets/redimage.png';

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/amenities' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   const [profileData, setProfileData] = useState(null);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
        
//         if (location.pathname === '/sell-properties') {
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             dispatch(setUser(userToStore));
//             fetchUserProfile();
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id && user?.token) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected, refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       console.log('🚪 Starting logout process...');
//       setProfileData(null);
//       dispatch(logout());
//       await persistor.purge();
//       await persistor.flush();
//       localStorage.clear();
//       sessionStorage.clear();
//       closeLogoutDialog();
//       navigate('/', { replace: true });
//       setTimeout(() => {
//         window.location.href = '/';
//       }, 100);
//       console.log('✅ Logout completed successfully');
//     } catch (error) {
//       console.error('❌ Error during logout:', error);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = '/';
//     }
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   const handleListPropertyClick = () => {
//     setDrawerOpen(false);
    
//     if (!user) {
//       navigate('/login');
//       return;
//     }

//     navigate('/add-new-property');
//   };

//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         {user ? (
//           <>
//             <ListItem button onClick={handleDashboardClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Dashboard"
//               />
//             </ListItem>

//             <ListItem button onClick={handleProfileClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Edit Profile"
//               />
//             </ListItem>

//             <ListItem button onClick={handleMyPropertiesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Properties"
//               />
//             </ListItem>

//             <ListItem button onClick={handleInboxClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Inbox"
//               />
//             </ListItem>

//             <ListItem button onClick={handleTransactionsClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Transactions"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={handleMyActivityClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Activity"
//               />
//             </ListItem>

//             <ListItem button onClick={handleWishlistClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Wishlist"
//               />
//             </ListItem>

//             <ListItem button onClick={handleRecentSearchesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Recent Searches"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={openLogoutDialog}>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Logout"
//               />
//             </ListItem>
//           </>
//         ) : (
//           <ListItem>
//             <ListItemText
//               primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500, textAlign: 'center' } }}
//               primary="Please sign in to access menu"
//             />
//           </ListItem>
//         )}
//       </List>
//     </Box>
//   );

//   const userName = user?.fullName || profileData?.full_name || '';
//   const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       {/* ✅ CSS Animation for FREE badge */}
//       <style>
//         {`
//           @keyframes swingBadge {
//             0%, 100% {
//               transform: rotate(-10deg);
//             }
//             50% {
//               transform: rotate(10deg);
//             }
//           }
          
//           .free-badge {
//             animation: swingBadge 2s ease-in-out infinite;
//             transform-origin: top center;
//           }
//         `}
//       </style>

//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             overflow: 'visible',
//             minHeight: { xs: '56px', sm: '64px' },
//             px: { xs: 0, sm: 2 },
//           }}
//         >
//           {/* Logo Section */}
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//             <Box
//               sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 gap: { xs: 0.5, sm: 1 }, 
//                 cursor: 'pointer' 
//               }}
//               onClick={() => navigate('/')}
//             >
//               <img 
//                 src={home} 
//                 alt="logo" 
//                 style={{ 
//                   height: window.innerWidth < 600 ? 32 : 38 
//                 }} 
//               />
//               {/* Desktop - Show proptitle */}
//               <Box sx={{ display: { xs: 'none', md: 'block' } }}>
//                 <img 
//                   src={proptitle} 
//                   alt="logo" 
//                   style={{ height: 18, width: 250 }} 
//                 />
//               </Box>
//               {/* Mobile - Show propmenu */}
//               <Box sx={{ display: { xs: 'block', md: 'none' } }}>
//                 <img 
//                   src={propmenu} 
//                   alt="logo" 
//                   style={{ 
//                     height: window.innerWidth < 400 ? 26 : 18,
//                     maxWidth: '100%',
//                     objectFit: 'contain'
//                   }} 
//                 />
//               </Box>
//             </Box>
//           </Box>

//           {/* Desktop View */}
//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     key={userProfileImage}
//                     src={userProfileImage}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {/* ✅ FIXED: Desktop Post Property with Badge Below (No Overlap) */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#ffc107', 
//                         textTransform: 'none', 
//                         fontWeight: 500,
//                         '&:hover': {
//                           backgroundColor: 'transparent',
//                           textDecoration: 'underline'
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: '32px',
//                         height: '32px',
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-8px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}

//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#ffc107',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#ffc107',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 <Button
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#ffc107',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   sx={{ color: '#ffc107', fontWeight: 500 }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* ✅ FIXED: Desktop Post Property for Non-logged with Badge Below (No Overlap) */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#ffc107', 
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         '&:hover': {
//                           backgroundColor: 'transparent',
//                           textDecoration: 'underline'
//                         }
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: '32px',
//                         height: '32px',
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-8px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Mobile View */}
//           <Box sx={{ 
//             display: { xs: 'flex', md: 'none' }, 
//             alignItems: 'center', 
//             gap: { xs: 0.5, sm: 1 },
//             mr: 1
//           }}>
//             {!user ? (
//               <>
//                 {/* Sign In Button - Mobile */}
//                 <Button
//                   component={Link}
//                   to="/login"
//                   size="small"
//                   sx={{ 
//                     color: '#ffc107', 
//                     fontWeight: 500,
//                     fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                     minWidth: 'auto',
//                     px: { xs: 1, sm: 1.5 },
//                     textTransform: 'none'
//                   }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* ✅ FIXED: Mobile Post Property with Badge Below */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       size="small"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#ffc107',
//                         fontWeight: 500,
//                         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                         minWidth: 'auto',
//                         px: { xs: 1, sm: 1.5 },
//                         textTransform: 'none',
//                         whiteSpace: 'nowrap'
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: { xs: '24px', sm: '28px' },
//                         height: { xs: '24px', sm: '28px' },
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-6px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             ) : (
//               <>
//                 {/* ✅ FIXED: Mobile Post Property for Logged Users with Badge Below */}
//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                     <Button
//                       size="small"
//                       onClick={handleListPropertyClick}
//                       sx={{ 
//                         color: '#ffc107',
//                         fontWeight: 500,
//                         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                         minWidth: 'auto',
//                         px: { xs: 1, sm: 1.5 },
//                         textTransform: 'none',
//                         whiteSpace: 'nowrap'
//                       }}
//                     >
//                       Post Property
//                     </Button>
                    
//                     {/* Animated FREE Badge - Positioned Below Button */}
//                     <Box
//                       className="free-badge"
//                       sx={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: { xs: '24px', sm: '28px' },
//                         height: { xs: '24px', sm: '28px' },
//                         zIndex: 10,
//                         pointerEvents: 'none',
//                         marginTop: '-6px'
//                       }}
//                     >
//                       <img 
//                         src={freeTag} 
//                         alt="free" 
//                         style={{ 
//                           width: '100%', 
//                           height: '100%',
//                           objectFit: 'contain'
//                         }} 
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>

//                     {/* Menu Icon - Mobile (Only show when user is logged in) */}
//           {user && (
//             <IconButton
//               onClick={toggleDrawer(true)}
//               sx={{ 
//                 display: { md: 'none' }, 
//                 color: 'inherit',
//                 p: { xs: 0.5, sm: 1 }
//               }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       <Toolbar />

//       {/* Logout Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Navbar;
















// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import propmenu from '../assets/menutitle.png';
// import pdtnav from '../assets/pdtnav.jpg';

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/amenities' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   const [profileData, setProfileData] = useState(null);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
        
//         if (location.pathname === '/sell-properties') {
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             dispatch(setUser(userToStore));
//             fetchUserProfile();
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id && user?.token) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected, refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       console.log('🚪 Starting logout process...');
//       setProfileData(null);
//       dispatch(logout());
//       await persistor.purge();
//       await persistor.flush();
//       localStorage.clear();
//       sessionStorage.clear();
//       closeLogoutDialog();
//       navigate('/', { replace: true });
//       setTimeout(() => {
//         window.location.href = '/';
//       }, 100);
//       console.log('✅ Logout completed successfully');
//     } catch (error) {
//       console.error('❌ Error during logout:', error);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = '/';
//     }
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   const handleListPropertyClick = () => {
//     setDrawerOpen(false);
    
//     if (!user) {
//       navigate('/login');
//       return;
//     }

//     navigate('/add-new-property');
//   };

//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         {user ? (
//           <>
//             <ListItem button onClick={handleDashboardClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Dashboard"
//               />
//             </ListItem>

//             <ListItem button onClick={handleProfileClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Edit Profile"
//               />
//             </ListItem>

//             <ListItem button onClick={handleMyPropertiesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Properties"
//               />
//             </ListItem>

//             <ListItem button onClick={handleInboxClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Inbox"
//               />
//             </ListItem>

//             <ListItem button onClick={handleTransactionsClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Transactions"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={handleMyActivityClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Activity"
//               />
//             </ListItem>

//             <ListItem button onClick={handleWishlistClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Wishlist"
//               />
//             </ListItem>

//             <ListItem button onClick={handleRecentSearchesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Recent Searches"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={openLogoutDialog}>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Logout"
//               />
//             </ListItem>
//           </>
//         ) : (
//           <ListItem>
//             <ListItemText
//               primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500, textAlign: 'center' } }}
//               primary="Please sign in to access menu"
//             />
//           </ListItem>
//         )}
//       </List>
//     </Box>
//   );

//   const userName = user?.fullName || profileData?.full_name || '';
//   const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             overflow: 'hidden',
//             minHeight: { xs: '56px', sm: '64px' },
//             px: { xs: 0, sm: 2 },
//           }}
//         >
//           {/* Logo Section */}
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//             <Box
//               sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 gap: { xs: 0.5, sm: 1 }, 
//                 cursor: 'pointer' 
//               }}
//               onClick={() => navigate('/')}
//             >
//               <img 
//                 src={home} 
//                 alt="logo" 
//                 style={{ 
//                   height: window.innerWidth < 600 ? 32 : 38 
//                 }} 
//               />
//               {/* Desktop - Show proptitle */}
//               <Box sx={{ display: { xs: 'none', md: 'block' } }}>
//                 <img 
//                   src={proptitle} 
//                   alt="logo" 
//                   style={{ height: 18, width: 250 }} 
//                 />
//               </Box>
//               {/* Mobile - Show propmenu */}
//               <Box sx={{ display: { xs: 'block', md: 'none' } }}>
//                 <img 
//                   src={propmenu} 
//                   alt="logo" 
//                   style={{ 
//                     height: window.innerWidth < 400 ? 26 : 18,
//                     maxWidth: '100%',
                   
//                     objectFit: 'contain'
//                   }} 
//                 />
//               </Box>
//             </Box>
//           </Box>

//           {/* Desktop View */}
//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     key={userProfileImage}
//                     src={userProfileImage}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff', textTransform: 'none', fontWeight: 500 }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}

//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#ffc107',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#ffc107',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 <Button
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#ffc107',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   sx={{ color: '#ffc107', fontWeight: 500 }}
//                 >
//                   Sign In
//                 </Button>

//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff' }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Mobile View - Sign In and Post Property in Navbar */}
//           <Box sx={{ 
//             display: { xs: 'flex', md: 'none' }, 
//             alignItems: 'center', 
//             gap: { xs: 0.5, sm: 1 },
//             mr: 1
//           }}>
//             {!user ? (
//               <>
//                 {/* Sign In Button - Mobile */}
//                 <Button
//                   component={Link}
//                   to="/login"
//                   size="small"
//                   sx={{ 
//                     color: '#ffc107', 
//                     fontWeight: 500,
//                     fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                     minWidth: 'auto',
//                     px: { xs: 1, sm: 1.5 },
//                     textTransform: 'none'
//                   }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* Post Property Button - Mobile */}
//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     size="small"
//                     onClick={handleListPropertyClick}
//                     sx={{ 
//                       color: '#ffc107',
//                       fontWeight: 500,
//                       fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                       minWidth: 'auto',
//                       px: { xs: 1, sm: 1.5 },
//                       textTransform: 'none',
//                       whiteSpace: 'nowrap'
//                     }}
//                   >
//                     Post Property
//                   </Button>
//                 )}
//               </>
//             ) : (
//               <>
//                 {/* Post Property Button for logged-in users - Mobile */}
//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     size="small"
//                     onClick={handleListPropertyClick}
//                     sx={{ 
//                       color: '#ffc107',
//                       fontWeight: 500,
//                       fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                       minWidth: 'auto',
//                       px: { xs: 1, sm: 1.5 },
//                       textTransform: 'none',
//                       whiteSpace: 'nowrap'
//                     }}
//                   >
//                     Post Property
//                   </Button>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* ✅ UPDATED: Menu Icon - Mobile (Only show when user is logged in) */}
//           {user && (
//             <IconButton
//               onClick={toggleDrawer(true)}
//               sx={{ 
//                 display: { md: 'none' }, 
//                 color: 'inherit',
//                 p: { xs: 0.5, sm: 1 }
//               }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       <Toolbar />

//       {/* Logout Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Navbar;







// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import pdtnav from '../assets/pdtnav.jpg';

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/amenities' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   const [profileData, setProfileData] = useState(null);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
        
//         if (location.pathname === '/sell-properties') {
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             dispatch(setUser(userToStore));
//             fetchUserProfile();
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id && user?.token) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected, refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       console.log('🚪 Starting logout process...');
//       setProfileData(null);
//       dispatch(logout());
//       await persistor.purge();
//       await persistor.flush();
//       localStorage.clear();
//       sessionStorage.clear();
//       closeLogoutDialog();
//       navigate('/', { replace: true });
//       setTimeout(() => {
//         window.location.href = '/';
//       }, 100);
//       console.log('✅ Logout completed successfully');
//     } catch (error) {
//       console.error('❌ Error during logout:', error);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = '/';
//     }
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   // ✅ FIXED: Just navigate, let AddNewProperty handle the dialog
//   const handleListPropertyClick = () => {
//     setDrawerOpen(false);
    
//     if (!user) {
//       navigate('/login');
//       return;
//     }

//     // ✅ Just navigate - AddNewProperty will show dialog if needed
//     navigate('/add-new-property');
//   };

//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         {!user ? (
//           <ListItem button component={Link} to="/login" onClick={() => setDrawerOpen(false)}>
//             <ListItemText
//               primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//               primary="Sign In"
//             />
//           </ListItem>
//         ) : (
//           <>
//             <ListItem button onClick={handleDashboardClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Dashboard"
//               />
//             </ListItem>

//             <ListItem button onClick={handleProfileClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Edit Profile"
//               />
//             </ListItem>

//             <ListItem button onClick={handleMyPropertiesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Properties"
//               />
//             </ListItem>

//             <ListItem button onClick={handleInboxClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Inbox"
//               />
//             </ListItem>

//             <ListItem button onClick={handleTransactionsClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Transactions"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={handleMyActivityClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Activity"
//               />
//             </ListItem>

//             <ListItem button onClick={handleWishlistClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Wishlist"
//               />
//             </ListItem>

//             <ListItem button onClick={handleRecentSearchesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Recent Searches"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             <ListItem button onClick={openLogoutDialog}>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Logout"
//               />
//             </ListItem>
//           </>
//         )}
//         <ListItem>
//           {!shouldHidePostPropertyButton && (
//             <Button
//               variant="contained"
//               fullWidth
//               sx={{ bgcolor: '#ffc107', color: '#fff' }}
//               onClick={handleListPropertyClick}
//             >
//               Post Property
//             </Button>
//           )}
//         </ListItem>
//       </List>
//     </Box>
//   );

//   const userName = user?.fullName || profileData?.full_name || '';
//   const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             overflow: 'hidden',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//             <Box
//               sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
//               onClick={() => navigate('/')}
//             >
//               <img src={home} alt="logo" style={{ height: 38 }} />
//               <img src={proptitle} alt="logo" style={{ height: 18, width: 250 }} />
//             </Box>
//           </Box>

//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     key={userProfileImage}
//                     src={userProfileImage}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff', textTransform: 'none', fontWeight: 500 }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}

//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#ffc107',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#ffc107',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 <Button
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#ffc107',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   sx={{ color: '#ffc107', fontWeight: 500 }}
//                 >
//                   Sign In
//                 </Button>

//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff' }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}
//               </>
//             )}
//           </Box>

//           <IconButton
//             onClick={toggleDrawer(true)}
//             sx={{ display: { md: 'none' }, color: 'inherit' }}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       <Toolbar />

//       {/* Logout Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Navbar;


// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import Lottie from 'lottie-react';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
//   styled,
//   keyframes,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import menutitle from '../assets/menutitle.png';
// import pdtnav from '../assets/pdtnav.jpg';

// // Swinging animation for the FREE badge
// const swingAnimation = keyframes`
//   0% {
//     transform: rotate(0deg);
//   }
//   20% {
//     transform: rotate(15deg);
//   }
//   40% {
//     transform: rotate(-10deg);
//   }
//   60% {
//     transform: rotate(5deg);
//   }
//   80% {
//     transform: rotate(-5deg);
//   }
//   100% {
//     transform: rotate(0deg);
//   }
// `;

// // Styled component for the hanging string
// const HangingString = styled(Box)({
//   position: 'absolute',
//   top: -20,
//   left: '50%',
//   transform: 'translateX(-50%)',
//   width: '2px',
//   height: '20px',
//   backgroundColor: '#D4A574',
//   transformOrigin: 'top center',
//   zIndex: 11,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: -6,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: '8px',
//     height: '8px',
//     borderRadius: '50%',
//     backgroundColor: '#333',
//     boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
//   }
// });

// // Styled component for the FREE badge container with swinging effect
// const FreeBadgeContainer = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: -12,
//   right: -12,
//   backgroundColor: '#C41E3A',
//   color: '#fff',
//   fontSize: '11px',
//   fontWeight: 700,
//   padding: '6px 12px',
//   borderRadius: '6px',
//   boxShadow: '0 4px 15px rgba(196, 30, 58, 0.4)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   zIndex: 10,
//   border: '2px solid #fff',
//   transformOrigin: 'top center',
//   animation: `${swingAnimation} 3s ease-in-out infinite`,
//   cursor: 'pointer',
//   transition: 'transform 0.3s ease',
//   '&:hover': {
//     animation: `${swingAnimation} 1s ease-in-out infinite`,
//   }
// }));

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/amenities' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   const [profileData, setProfileData] = useState(null);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
        
//         if (location.pathname === '/sell-properties') {
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             dispatch(setUser(userToStore));
//             fetchUserProfile();
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id && user?.token) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected, refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing navbar data...');
//         fetchUserProfile();
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [user?.id, user?.token]);

//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       console.log('🚪 Starting logout process...');
//       setProfileData(null);
//       dispatch(logout());
//       await persistor.purge();
//       await persistor.flush();
//       localStorage.clear();
//       sessionStorage.clear();
//       closeLogoutDialog();
//       navigate('/', { replace: true });
//       setTimeout(() => {
//         window.location.href = '/';
//       }, 100);
//       console.log('✅ Logout completed successfully');
//     } catch (error) {
//       console.error('❌ Error during logout:', error);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = '/';
//     }
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   const handleListPropertyClick = () => {
//     setDrawerOpen(false);
    
//     if (!user) {
//       navigate('/login');
//       return;
//     }

//     navigate('/add-new-property');
//   };

//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   // FREE Badge Component with swinging animation
//   const FreeBadge = ({ size = 'normal' }) => {
//     const isSmall = size === 'small';
    
//     return (
//       <Box sx={{ position: 'relative' }}>
//         <HangingString 
//           sx={{
//             animation: `${swingAnimation} 3s ease-in-out infinite`,
//             height: isSmall ? '15px' : '20px',
//             top: isSmall ? -15 : -20,
//           }}
//         />
//         <FreeBadgeContainer
//           sx={{
//             fontSize: isSmall ? '9px' : '11px',
//             padding: isSmall ? '4px 8px' : '6px 12px',
//             top: isSmall ? -8 : -12,
//             right: isSmall ? -8 : -12,
//           }}
//         >
//           FREE
//         </FreeBadgeContainer>
//       </Box>
//     );
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         <ListItem button onClick={handleDashboardClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Dashboard"
//           />
//         </ListItem>

//         <ListItem button onClick={handleProfileClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Edit Profile"
//           />
//         </ListItem>

//         <ListItem button onClick={handleMyPropertiesClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="My Properties"
//           />
//         </ListItem>

//         <ListItem button onClick={handleInboxClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Inbox"
//           />
//         </ListItem>

//         <ListItem button onClick={handleTransactionsClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Transactions"
//           />
//         </ListItem>

//         <Divider sx={{ my: 1 }} />

//         <ListItem button onClick={handleMyActivityClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="My Activity"
//           />
//         </ListItem>

//         <ListItem button onClick={handleWishlistClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Wishlist"
//           />
//         </ListItem>

//         <ListItem button onClick={handleRecentSearchesClick}>
//           <ListItemIcon sx={{ minWidth: '40px' }}>
//             <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//           </ListItemIcon>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Recent Searches"
//           />
//         </ListItem>

//         <Divider sx={{ my: 1 }} />

//         <ListItem button onClick={openLogoutDialog}>
//           <ListItemText
//             primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//             primary="Logout"
//           />
//         </ListItem>
//       </List>
//     </Box>
//   );

//   const userName = user?.fullName || profileData?.full_name || '';
//   const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             overflow: 'hidden',
//             padding: { xs: '0 8px', md: '0 16px' }
//           }}
//         >
//           {/* Logo Section */}
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: { xs: 0, md: 1 } }}>
//             <Box
//               sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
//               onClick={() => navigate('/')}
//             >
//               <img src={home} alt="logo" style={{ height: 38 }} />
//               <img 
//                 src={proptitle} 
//                 alt="logo" 
//                 style={{ 
//                   height: 18, 
//                   width: 250,
//                   display: 'block'
//                 }} 
//                 className="desktop-logo"
//               />
//               <img 
//                 src={menutitle} 
//                 alt="logo" 
//                 style={{ 
//                   height: 14, 
//                   width: 'auto',
//                   maxWidth: 120,
//                   display: 'none'
//                 }} 
//                 className="mobile-logo"
//               />
//             </Box>
//           </Box>

//           {/* Desktop Actions */}
//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     key={userProfileImage}
//                     src={userProfileImage}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative' }}>
//                     <Button
//                       variant="outlined"
//                       sx={{ 
//                         color: '#ffc107',
//                         borderColor: '#ffc107',
//                         textTransform: 'none', 
//                         fontWeight: 500,
//                         '&:hover': {
//                           borderColor: '#ffc107',
//                           backgroundColor: 'rgba(255, 193, 7, 0.04)'
//                         }
//                       }}
//                       onClick={handleListPropertyClick}
//                     >
//                       Post Property
//                     </Button>
//                     <FreeBadge />
//                   </Box>
//                 )}

//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#ffc107',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#ffc107',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 <Button
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#ffc107',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   sx={{ color: '#ffc107', fontWeight: 500, textTransform: 'none' }}
//                 >
//                   Sign In
//                 </Button>

//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative' }}>
//                     <Button
//                       variant="outlined"
//                       sx={{ 
//                         color: '#ffc107',
//                         borderColor: '#ffc107',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         '&:hover': {
//                           borderColor: '#ffc107',
//                           backgroundColor: 'rgba(255, 193, 7, 0.04)'
//                         }
//                       }}
//                       onClick={handleListPropertyClick}
//                     >
//                       Post Property
//                     </Button>
//                     <FreeBadge />
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Mobile Actions */}
//           <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1 }}>
//             {!user ? (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   size="small"
//                   sx={{ 
//                     color: '#ffc107', 
//                     fontWeight: 500, 
//                     textTransform: 'none',
//                     fontSize: '13px',
//                     minWidth: 'auto',
//                     padding: '4px 8px'
//                   }}
//                 >
//                   Sign In
//                 </Button>

//                 {!shouldHidePostPropertyButton && (
//                   <Box sx={{ position: 'relative' }}>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       sx={{ 
//                         color: '#ffc107',
//                         borderColor: '#ffc107',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         fontSize: '12px',
//                         padding: '4px 10px',
//                         minWidth: 'auto',
//                         '&:hover': {
//                           borderColor: '#ffc107',
//                           backgroundColor: 'rgba(255, 193, 7, 0.04)'
//                         }
//                       }}
//                       onClick={handleListPropertyClick}
//                     >
//                       Post
//                     </Button>
//                     <FreeBadge size="small" />
//                   </Box>
//                 )}
//               </>
//             ) : (
//               <IconButton
//                 onClick={toggleDrawer(true)}
//                 sx={{ color: 'inherit' }}
//               >
//                 <MenuIcon />
//               </IconButton>
//             )}
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Drawer for logged-in users only */}
//       {user && (
//         <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//           {drawerContent}
//         </Drawer>
//       )}

//       <Toolbar />

//       {/* Logout Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add responsive CSS for logo switching */}
//       <style jsx global>{`
//         @media (max-width: 899px) {
//           .desktop-logo {
//             display: none !important;
//           }
//           .mobile-logo {
//             display: block !important;
//           }
//         }
//         @media (min-width: 900px) {
//           .desktop-logo {
//             display: block !important;
//           }
//           .mobile-logo {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </Box>
//   );
// };

// export default Navbar;
